import React from "react";
import styles from "./UiPrimitives.module.css";

const UiSectionCard = ({
  title,
  extra,
  children,
  className,
  bodyClassName,
  headerClassName,
}) => {
  return (
    /* `ui-section-card` is a plain, unhashed hook: the pharmacy module's motion
       sheet needs a selector it can name, and a CSS-module class is rewritten
       to something it cannot. */
    <section className={["ui-section-card", styles.sectionCard, className].filter(Boolean).join(" ")}>
      {(title || extra) && (
        <header
          className={[styles.sectionCardHeader, headerClassName]
            .filter(Boolean)
            .join(" ")}
        >
          {title ? <div className={styles.sectionCardTitle}>{title}</div> : <div />}
          {extra}
        </header>
      )}
      <div className={[styles.sectionCardBody, bodyClassName].filter(Boolean).join(" ")}>
        {children}
      </div>
    </section>
  );
};

export default UiSectionCard;
